module.exports = __webpack_public_path__ + "static/img/areaB_07.fa5d3e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_07.png
// module id = 1259
// module chunks = 1